import PropTypes from 'prop-types';
import { PtgFeaturesWeb } from './PtgFeaturesWeb.js';
import { PtgFeaturesPdf } from './PtgFeaturesPdf.js';
import { handleImageContent } from '../eflyer-utils.js';

const PTG_FEATURES_TEMPLATE_ID = '01K0QGF9150QW2GMERBPM2ZAAA';

const PtgFeaturesTemplate = props => {
  const { content, themeApplication } = props;
  const {
    features,
    paragraph,
    mainImage,
    callToAction,
    heading1,
    footer,
    title,
    heading2,
    featuresHeading = 'Features & Benefits'
  } = content.fields;

  const context = {
    logoUrl: handleImageContent(themeApplication.logoAsset),
    heading1: heading1.value,
    heading2: heading2.value,
    title: title.value,
    mainImageUrl: handleImageContent(mainImage.value),
    paragraph: paragraph.value,
    featuresHeading: featuresHeading,
    features: features.value,
    callToAction: callToAction.value,
    qrUrl: window.location.origin,
    footer: footer.value,
    themeColors: themeApplication.primaryColor
  };

  const isPdf = location.pathname.includes('/pdf');

  return isPdf ? (
    <PtgFeaturesPdf context={context} />
  ) : (
    <PtgFeaturesWeb context={context} />
  );
};

PtgFeaturesTemplate.propTypes = {
  content: PropTypes.shape({
    fields: PropTypes.shape({
      features: PropTypes.shape({
        value: PropTypes.any
      }),
      paragraph: PropTypes.shape({
        value: PropTypes.string
      }),
      mainImage: PropTypes.shape({
        value: PropTypes.shape({
          contentUrl: PropTypes.string
        })
      }),
      callToAction: PropTypes.shape({
        value: PropTypes.string
      }),
      heading1: PropTypes.shape({
        value: PropTypes.string
      }),
      footer: PropTypes.shape({
        value: PropTypes.any
      }),
      logo: PropTypes.shape({
        value: PropTypes.shape({
          contentUrl: PropTypes.string
        })
      }),
      title: PropTypes.shape({
        value: PropTypes.string
      }),
      heading2: PropTypes.shape({
        value: PropTypes.string
      }),
      featuresHeading: PropTypes.string
    }).isRequired
  }).isRequired,
  location: PropTypes.any
};

export default PtgFeaturesTemplate;
export { PtgFeaturesTemplate, PTG_FEATURES_TEMPLATE_ID };
